import React from 'react';
import NavbarHome from '../Components/NavbarHome';
import Rally from '../Images/Rally.png'

export default function Header() {
    return (
        <div className="bheader">
            <NavbarHome />
            <div className='text-[6vw] lg:text-6xl flex flex-col items-center justify-center h-[80vh]'>
                <img className='w-[50vw] md:w-96' src={Rally} alt="Rally Logo" />
                <div className='font-bold flex flex-col text-center py-4'>
                    <p>ENTREPRENEURSHIP</p>
                    <p className='text-[8vw] md:text-[8vw] lg:text-[82px]'>RALLY SOCIETY</p>
                    <div className='bg-[#F4DC7C] h-1 w-[95%] m-auto my-4'></div>
                    <p className='text-[4vw] md:text-[36px] text-[#ed5955] font-semibold'>ABU QIR BRANCH</p>
                </div>
            </div>
        </div>
    );
}